export default __webpack_public_path__ + "static/media/multi-asset-fund-weather-mobbanner.0a43e92a.jpg";